module.exports = __webpack_public_path__ + "img/illu.2c503886.svg";